'use strict';

const STORAGE_KEY = 'coda_pvp_queue_intent';

/**
 * @param {string|number} strategyId
 * @param {number} [queuedAt]
 */
export function savePvpQueueIntent(strategyId, queuedAt) {
  if (strategyId == null || strategyId === '') {
    throw new Error('savePvpQueueIntent: strategyId is required');
  }
  const at = typeof queuedAt === 'number' && Number.isFinite(queuedAt) ? queuedAt : Date.now();
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      strategyId: String(strategyId),
      queuedAt: at,
    })
  );
}

/**
 * @returns {{ strategyId: string, queuedAt: number } | null}
 */
export function readPvpQueueIntent() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }
  const parsed = JSON.parse(raw);
  if (!parsed || typeof parsed.strategyId !== 'string' || parsed.strategyId.length === 0) {
    throw new Error('readPvpQueueIntent: stored intent is missing strategyId');
  }
  if (typeof parsed.queuedAt !== 'number' || !Number.isFinite(parsed.queuedAt)) {
    throw new Error('readPvpQueueIntent: stored intent is missing queuedAt');
  }
  return { strategyId: parsed.strategyId, queuedAt: parsed.queuedAt };
}

export function clearPvpQueueIntent() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function buildQueueStateFromIntent(intent) {
  if (!intent) {
    return null;
  }
  return {
    inQueue: true,
    strategyId: intent.strategyId,
    elapsedSeconds: Math.max(0, Math.floor((Date.now() - intent.queuedAt) / 1000)),
    statusMessage: '',
  };
}
